import type {
  CollectionReference,
  DocumentData,
  DocumentReference,
} from 'firebase/firestore'
import {
  collection,
  doc,
  type Firestore,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import type { FirebaseRepository } from '../../models/FirebaseRepository'
import { type FirestoreUserProfileSlideDeckReview, schema } from './schema'
import { unsupportedConverter } from '../shared/noops'
import { type StreamInterface } from 'tricklejs/dist/types'
import { documentSnapshots } from '../../firestore-mobx/stream'

const converter: FirestoreDataConverter<FirestoreUserProfileSlideDeckReview> = {
  toFirestore: unsupportedConverter,
  fromFirestore: (snapshot: QueryDocumentSnapshot) => {
    const data = snapshot.data({ serverTimestamps: 'estimate' })
    return schema.parse(data)
  },
}

export const getColRef = (
  firestore: Firestore,
  params: { userId: string }
): CollectionReference<FirestoreUserProfileSlideDeckReview, DocumentData> => {
  return collection(
    firestore,
    'user_profile',
    params.userId,
    'slide_deck_review'
  ).withConverter(converter)
}

export const getDocRef = (
  firestore: Firestore,
  params: {
    userId: string
    slideDeckId: string
  }
): DocumentReference<FirestoreUserProfileSlideDeckReview, DocumentData> => {
  const colRef = getColRef(firestore, params)

  return doc(colRef, params.slideDeckId)
}

export const getUserHasSlideDeckReviewDocument = (
  repository: FirebaseRepository,
  params: {
    userId: string
    slideDeckId: string
  }
): StreamInterface<boolean> => {
  const docRef = getDocRef(repository.firestore, params)
  return documentSnapshots(docRef).map((docSnap) => docSnap.exists())
}
